import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import '../../../components_style/doctorComponents/FormsStyle.css'
import SvGraphics from "../../../assets/SvGraphics";
import Error from "../../../components/single_components/Error";
import * as Yup from "yup";
import {OverlayTrigger} from "react-bootstrap";
import Popover from "react-bootstrap/Popover";
import {hasIchilovQuery} from "../../../utils/routeUtils";


class PainProgrammChooseTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 1,
            errors: this.props.errors
        };
    }

    onclickHasLicense = (name, value) => {
        this.props.onclickHasLicense(name, value)
    }

    onYesNoValueChange = (name, value) => {
        this.props.onYesNoValueChange(name, value)
    }

    onValueChange = (name, value) => {
        if (name === "Doctor_Indication") {
            let isLicense = value === "Indication1" || value === "Indication2" || value === "Indication3"
            this.props.onValueChange("IsLicense", isLicense)
        }
        this.props.onValueChange(name, value)
        if(value){
            this.onclickHasLicense("hasLicenseLastYear", this.props.entry.hasLicenseLastYear)
        }else{
            this.onclickHasLicense("hasLicenseLastYear", "")
        }
        // this.props.onValueChange(name, value)
    }
    render() {
        let {t, entry, filesToUpload} = this.props

        let programm = entry.choose_programm ? entry.choose_programm : ""
        programm = programm === "new" ? t('patient_self_boarding.new_license') : programm
        programm = programm === "renew" ? t('patient_self_boarding.renew_license') : programm
        programm = programm === "renew2" ? t('patient_self_boarding.renew2_license') : programm
        programm = programm === "newPrescription" ? t('patient_self_boarding.new_Prescription') : programm
        programm = programm === "renewPrescription" ? t('patient_self_boarding.renew_Prescription') : programm
        programm = programm === "renew2Prescription" ? t('patient_self_boarding.renew2_Prescription') : programm

        let isLeumit = entry.Insuring_factor ==='3'

        let doctorIndicationArr= [
            <option value="Indication1">{t('patient_self_boarding.Indication1')}</option>,
            <option value="Indication2">{t('patient_self_boarding.Indication2')}</option>,
            <option value="Indication3">{t('patient_self_boarding.Indication3')}</option>,
        ]

        if(isLeumit){
            doctorIndicationArr= [
                <option value="Indication1">{t('patient_self_boarding.Indication1')}</option>,
                <option value="Indication2">{t('patient_self_boarding.Indication2')}</option>,
                <option value="Indication3">{t('patient_self_boarding.Indication3')}</option>,
                <option value="Indication4">{t('patient_self_boarding.Indication4')}</option>,
                <option value="Indication5">{t('patient_self_boarding.Indication5')}</option>,
                <option value="Indication6">{t('patient_self_boarding.Indication6')}</option>,
                <option value="Indication7">{t('patient_self_boarding.Indication7')}</option>,
                <option value="Indication8">{t('patient_self_boarding.Indication8')}</option>,
                <option value="Indication9">{t('patient_self_boarding.Indication9')}</option>,
                <option value="Indication10">{t('patient_self_boarding.Indication10')}</option>,
                <option value="Indication11">{t('patient_self_boarding.Indication11')}</option>,
                <option value="Indication12">{t('patient_self_boarding.Indication12')}</option>,
                <option value="Indication13">{t('patient_self_boarding.Indication13')}</option>,
                <option value="Indication14">{t('patient_self_boarding.Indication14')}</option>,
            ]
        }else if(hasIchilovQuery()){
            doctorIndicationArr= [
                <option value="Indication1">{t('patient_self_boarding.Indication1')}</option>,
                <option value="Indication3">{t('patient_self_boarding.Indication3')}</option>
            ]
        }

        let filesArr = []

        if (filesToUpload.length > 0) {
            filesToUpload.map(item =>
                filesArr.push(
                    <div>
                        <div className="svg-doc-block">
                            <SvGraphics className="svg-doc" width={"16px"} height={"19px"}
                                        svgname={'document'}/>
                            <label className="label-doc">{item.Form_desc}</label>
                        </div>
                    </div>
                )
            )
        }


        return (
            <div className={'patientForm-box-container'}>

                <div className={'patientsFormBoxes-visitSummary'}>

                    <div className={'patientsFormRow'}>
                        <div style={{width: "100%", minWidth: '330px'}}>

                            <div className={'inputSlotsFlex'} style={{maxWidth:'50px'}}>
                                <div className={'infoLabel-error-block'}>
                                    <label
                                        className={'infoLabel-black'}>{t('patient_self_boarding.doctorIndication')}*</label>
                                </div>
                                <select className={'selectBox'} id="Doctor_Indication" name="Doctor_Indication"
                                        value={entry.Doctor_Indication} onChange={(e)=>this.onValueChange(e.target.name,e.target.value)}>
                                    <option/>
                                    {doctorIndicationArr}
                                </select>
                                <Error errorClass={'error-message-label-flex'}
                                       isShown={!!(this.props.errors)['Doctor_Indication']}
                                       errorMessage={(this.props.errors)['Doctor_Indication']}/>
                            </div>


                            {entry.Doctor_Indication  && <div className={'inputSlotsFlex'} style={{marginTop:'30px'}}>
                                <div className={'infoLabel-error-block'}>
                                    <label
                                        className={'infoLabel-black'}>{entry.IsLicense?t('patient_self_boarding.hasLicenseLastYear'):t('patient_self_boarding.hasPrescriptionLastYear')}*</label>
                                </div>
                                <div className={'inputBoxStyle-yes-no-block'}>
                                    <button tabIndex={0}
                                            className={entry.hasLicenseLastYear === "Yes" ? 'inputBoxStyle-yes-no-left-selected' : 'inputBoxStyle-yes-no-left'}
                                            onClick={() => this.onclickHasLicense("hasLicenseLastYear", "Yes")}>{t('patient_self_boarding.yes')}
                                    </button>
                                    <button tabIndex={0}
                                            className={entry.hasLicenseLastYear === "No" ? 'inputBoxStyle-yes-no-right-selected' : 'inputBoxStyle-yes-no-right'}
                                            onClick={() => this.onclickHasLicense("hasLicenseLastYear", "No")}>{t('patient_self_boarding.no')}
                                    </button>
                                </div>
                                <Error errorClass={'error-message-label-flex'}
                                       isShown={!!(this.props.errors)['hasLicenseLastYear']}
                                       errorMessage={(this.props.errors)['hasLicenseLastYear']}/>
                            </div>}
                            {entry.hasLicenseLastYear === "Yes" &&
                                <div className={'inputSlotsFlex'}>
                                    <div className={'infoLabel-error-block'}>
                                        <label
                                            className={'infoLabel-black2'}>{t('patient_self_boarding.renewCurrentDose')}*</label>
                                        <OverlayTrigger
                                            placement={"bottom"}
                                            delay={{show: 250, hide: 250}}
                                            trigger={"click"}
                                            rootClose
                                            overlay={
                                                <Popover id="popover-faqs">
                                                    <Popover.Content>
                                                        <div className={'faqs-element'}>
                                                            <label
                                                                className={'faqs-element-label'}>{t('patient_self_boarding.Dose_change_text')}</label>
                                                        </div>
                                                    </Popover.Content>
                                                </Popover>
                                            }>
                                            <SvGraphics svgname={'info-icon'} className={'faqs-element-svg2'}/>
                                        </OverlayTrigger>
                                    </div>
                                    <div className={'inputBoxStyle-yes-no-block'}>

                                        <button tabIndex={0}
                                                className={entry.renewCurrentDose === "Yes" ? 'inputBoxStyle-yes-no-left-selected' : 'inputBoxStyle-yes-no-left'}
                                                onClick={() => this.onYesNoValueChange("renewCurrentDose", "Yes")}>{t('patient_self_boarding.yes')}
                                        </button>
                                        <button tabIndex={0}
                                                className={entry.renewCurrentDose === "No" ? 'inputBoxStyle-yes-no-right-selected' : 'inputBoxStyle-yes-no-right'}
                                                onClick={() => this.onYesNoValueChange("renewCurrentDose", "No")}>{t('patient_self_boarding.no')}
                                        </button>
                                    </div>
                                    <Error errorClass={'error-message-label-flex'}
                                           isShown={!!(this.props.errors)['renewCurrentDose']}
                                           errorMessage={(this.props.errors)['renewCurrentDose']}/>
                                </div>
                            }

                            {entry.renewCurrentDose === "Yes" && entry.hasLicenseLastYear === "Yes" &&
                                <div style={{display: 'block'}}>
                                    <div style={{height: '60px'}}>
                                        <label
                                            className={'infoLabel-changeDose'}>{t('patient_self_boarding.renewCurrentDoseInfo')}</label>
                                    </div>
                                    <div style={{height: '60px'}}>
                                        <label
                                            className={'infoLabel-changeDose'}>{t('patient_self_boarding.renewCurrentDoseInfo2')}</label>
                                    </div>
                                </div>
                            }

                            {entry.hasLicenseLastYear && entry.Doctor_Indication &&
                                <div className={'patientsFormRow'}>
                                    <div className={'line-space'} style={{marginBottom: '40px', marginTop: '40px'}}/>
                                </div>
                            }
                            {entry.hasLicenseLastYear && entry.Doctor_Indication &&
                                <div>
                                    <div className={'infoLabel-requestPay'}>
                                        <label>{t('patient_self_boarding.requestAmount')}</label>
                                    </div>
                                    <div className={'blankSpace'}/>

                                    <div className={'program_payment_box'}>
                                        <div className={'requestType-Box'}>
                                            <SvGraphics style={{margin: '20px 8px 19px'}} width={"16px"} height={"19px"}
                                                        svgname={'requestIcon'}/>
                                            <label className={'requestType-label'} style={{
                                                width: '90%',
                                                lineHeight: '1.0',
                                                marginTop: '18px'
                                            }}>{programm}</label>

                                        </div>
                                        <div className={'requestPay-Box'}>{entry.toPay} ₪</div>
                                    </div>
                                    <div className={'blankSpace'}/>

                                </div>
                            }

                            {entry.hasLicenseLastYear  && entry.Doctor_Indication&&
                                <div>
                                    <div className={'infoLabel-requestPay'} id={'infoLabel-requestPay'}
                                         style={{width: '90%', lineHeight: '1.0'}}>
                                        <label>{t('patient_self_boarding.neededDocs')}</label>
                                    </div>
                                    <div className={'infoLabel-requestPay-Forms'}>
                                        {filesArr}
                                    </div>
                                </div>

                            }

                        </div>
                    </div>
                </div>


            </div>
        );
    }
}


const PainProgrammChooseTab = compose(
    withTranslation(),
)(PainProgrammChooseTabComposed);

export default PainProgrammChooseTab;
